export const MODES = {
    VIEW: 'view',
    BROWSER: 'browser',
    REPLACE: 'replace',
};
